import React, { useMemo } from 'react';
import { drop, isEmpty, take } from 'lodash';
import ServiceListRow from './ServiceListRow';
import ServiceListPlaceholder from './ServiceListPlaceholder';

function ServiceList({ serviceAngebote = [], filterValues }) {
    const filteredServiceAngebote = useMemo(() => {
        const { serviceUrls, automodell, automarke, preisspanne } = filterValues;

        let filteredServiceAngebote = serviceAngebote;
        if (!isEmpty(serviceUrls)) {
            filteredServiceAngebote = filteredServiceAngebote.filter(product => serviceUrls.includes(product.serviceUrl));
        }
        if (!isEmpty(automodell)) {
            filteredServiceAngebote = filteredServiceAngebote.filter(product => automodell.includes(product.autoModell));
        }
        if (!isEmpty(automarke)) {
            filteredServiceAngebote = filteredServiceAngebote.filter(product => automarke.includes(product.hauptFabrikat));
        }

        if (preisspanne.minPrice) {
            filteredServiceAngebote = filteredServiceAngebote.filter(product => preisspanne.minPrice <= product.preis.komplettPreis);
        }
        if (preisspanne.maxPrice) {
            filteredServiceAngebote = filteredServiceAngebote.filter(product => preisspanne.maxPrice >= product.preis.komplettPreis);
        }

        return filteredServiceAngebote;
    }, [filterValues, serviceAngebote]);

    return (
        <div className="uk-grid uk-grid-small uk-child-width-1-1@m" data-uk-grid="">
            {take(filteredServiceAngebote, 4).map(service => (
                <div key={service._id}>
                    <ServiceListRow service={service} />
                </div>
            ))}
            <ServiceListPlaceholder />
            {drop(filteredServiceAngebote, 4).map(service => (
                <div key={service._id}>
                    <ServiceListRow service={service} />
                </div>
            ))}
        </div>
    );
}

export default ServiceList;
